import { render, staticRenderFns } from "./RegisterComp.vue?vue&type=template&id=069ff01b"
import script from "./RegisterComp.vue?vue&type=script&lang=js"
export * from "./RegisterComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports